import Alert from "../elements/Alert";
import { usePortalPageTitle } from "./usePortalPageTitle";

export default function InvalidRole() {
  usePortalPageTitle("Invalid Role");

  return (
    <Alert
      className="m-3"
      text={"Invalid Role"}
    />
  );
}
